import type { ReactNode } from "react";
import { BrandLogo } from "../components/BrandLogo";
import { TenantBrand } from "../components/TenantBrand";
import { usePortalAuthConfig } from "./usePortalAuthConfig";

/**
 * The header above a portal's unauthenticated card: the DearBill logo and,
 * when the portal config carries tenant `branding`, the tenant's logo and
 * name, so the user sees which GPO the page belongs to.
 */
export function AuthBrandHeader(): ReactNode {
  const { branding } = usePortalAuthConfig();
  return (
    <div className="mb-12 flex flex-col items-center gap-6">
      <BrandLogo className="h-9" />
      {branding && (
        <TenantBrand
          name={branding.name}
          logoUrl={branding.logoUrl}
          className="text-midnight text-body-lg"
          logoClassName="h-10"
        />
      )}
    </div>
  );
}
